import { useState } from 'react';
import { Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { DashboardProvider, useDashboard } from '../contexts/DashboardContext';
import { ManagerHierarchyProvider } from '../contexts/ManagerHierarchyContext';
import { AdminAnalyticsHierarchyProvider } from '../contexts/AdminAnalyticsHierarchyContext';
import AdminSidebar from '../components/sidebar/AdminSidebar';
import ManagerSidebar from '../components/sidebar/ManagerSidebar';
import { getAdminViewMode } from '../utils/adminViewMode';

function DashboardLayoutInner() {
  const { loading, effectiveIsGlobal } = useDashboard();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [mobileOpen, setMobileOpen] = useState(false);
  const isAnalytics = location.pathname.startsWith('/admin/analytics');
  const analyticsHierarchyEnabled = isAnalytics || (
    location.pathname.startsWith('/bootcamp/') && !!searchParams.get('client')
  );

  const showManagerSidebar = !effectiveIsGlobal;

  if (loading) {
    return (
      <div className="dashboard-layout">
        <div className="dashboard-main">
          <div className="modern-loading" style={{ padding: 48 }}>Loading…</div>
        </div>
      </div>
    );
  }

  const Sidebar = showManagerSidebar ? ManagerSidebar : AdminSidebar;
  const shell = (
    <div className="dashboard-layout">
      <button
        type="button"
        className={`dashboard-mobile-toggle${mobileOpen ? ' dashboard-mobile-toggle-hidden' : ''}`}
        onClick={() => setMobileOpen((v) => !v)}
        aria-label="Toggle menu"
      >
        ☰
      </button>
      {mobileOpen && (
        <button
          type="button"
          className="dashboard-mobile-overlay"
          aria-label="Close menu"
          onClick={() => setMobileOpen(false)}
        />
      )}
      <Sidebar mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
      <main className="dashboard-main">
        <Outlet context={{ adminViewMode: getAdminViewMode() }} />
      </main>
    </div>
  );

  if (showManagerSidebar) {
    return <ManagerHierarchyProvider>{shell}</ManagerHierarchyProvider>;
  }

  return (
    <AdminAnalyticsHierarchyProvider enabled={analyticsHierarchyEnabled}>
      {shell}
    </AdminAnalyticsHierarchyProvider>
  );
}

function DashboardLayout() {
  return (
    <DashboardProvider>
      <DashboardLayoutInner />
    </DashboardProvider>
  );
}

export default DashboardLayout;
